import React, { useMemo } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Api from '../../../util/api';
import { convertImageToBlob } from '../../../util/image-functions';
const TextEditor2 = ({
  input,
  header = [1, 2, 3, false],
  fontOptions = ['bold', 'italic', 'underline', 'strike', 'blockquote'],
  ...props
}) => {
  const quillRef = React.useRef();

  const imageHandler = () => {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');
    input.click();

    input.onchange = async () => {
      const file = input.files[0];
      const formData = new FormData();
      const base64Image = await convertImageToBlob(file);
      const imageMime = base64Image.split(';base64')[0].split(':')[1];
      formData.append('image', file, {
        filename: file.name,
        contentType: imageMime,
      });

      try {
        const response = await Api.images.uploadImage(formData);
        const imageUrl = response.data.url;
        const editor = quillRef.current.getEditor();
        const range = editor.getSelection(true);
        if (range.index > 0) {
          editor.insertText(range.index, '\n');
        }
        editor.insertEmbed(range.index, 'image', imageUrl, 'user');
        // editor.formatText(range.index, 1, {
        //   width: 'auto',
        //   height: 'auto',
        // });
        editor.setSelection(range.index + 1, 0);
      } catch (error) {
        console.error('Error uploading image: ', error);
      }
    };
  };
  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          ['bold', 'italic', 'underline', 'strike'],
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ align: [] }],
          ['link', 'image'],
          ['clean'],
        ],
        handlers: {
          image: imageHandler,
        },
      },
    }),
    []
  );
  const toolbar = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image',
  ];
  return (
    <>
      <div className="text-editor">
        <ReactQuill
          ref={quillRef}
          modules={modules}
          toolbar={toolbar}
          theme="snow"
          value={input?.value}
          onChange={input.onChange}
        />
      </div>
      {props.meta?.touched && props.meta?.error && (
        <span className="form__form-group-error">{props.meta?.error}</span>
      )}
    </>
  );
};
export default TextEditor2;
